//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createFragmentContainer } from "react-relay";
// event-suggested-times-warning imports
import { IContainer, IProps, IState } from "./EventSuggestedTimesWarning.d";
import { eventSuggestedTimesWarningFragments } from "./EventSuggestedTimesWarning.gql";
import * as s from "./EventSuggestedTimesWarning.styles";
// other components
import { CalloutBox } from "@components/callout-box";
import { A } from "@ui";
import { InfoTip } from "@components/tool-tip";
// util
import { getCurrentWorkingGroup } from "@util/working-group.util";

//////////////////
// COMPONENT
//////////////////
class EventSuggestedTimesWarningCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  private toggle = (event: React.FormEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    this.setState({ expanded: !this.state.expanded });
  };

  private maybeRenderRemainder = (remainder: string[]) => {
    if (!remainder || !remainder.length) {
      return <span />;
    }

    return (
      <InfoTip
        targetElement={<li>and {remainder.length} more</li>}
        text={
          <ul>
            {remainder.map((calendar, i) => (
              <li key={i}>{calendar}</li>
            ))}
          </ul>
        }
        tipType={"info"}
        iconStyle={s.icon}
      />
    );
  };

  public render() {
    const { uncrawledCalendars, org } = this.props;
    const workingGroup = getCurrentWorkingGroup(org);
    const rooms = (workingGroup && workingGroup.rooms) || [];

    const displayNames = uncrawledCalendars.map((calendarId) => {
      const room = rooms.find((r) => r.roomId === calendarId);
      return (room && room.name) || calendarId;
    });

    const firstThree = displayNames.slice(0, 3);
    const remainder = displayNames.slice(3, displayNames.length);

    return (
      <CalloutBox warning style={s.container}>
        <div>
          Suggestions for this event do not take into account the availability of all attendees.
          <A onClick={this.toggle} style={s.containerLink} toggleable>
            {this.state.expanded ? " less" : " more"}
          </A>
        </div>
        <div style={this.state.expanded ? s.moreInfoExpanded : s.moreInfo}>
          Clockwise does not process calendar information for the following attendees:
          {firstThree.map((calendar, i) => (
            <li key={i}>{calendar}</li>
          ))}
          {this.maybeRenderRemainder(remainder)}
        </div>
      </CalloutBox>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const EventSuggestedTimesWarning = createFragmentContainer<IContainer>(
  EventSuggestedTimesWarningCmpt,
  eventSuggestedTimesWarningFragments,
);
